<template>
  <div class="child_">
    <a-form layout="horizontal" @submit="czSubmit" class="horizontal_item_" :form="form">
      <!-- 被保人信息始 -->
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">承租人意外险投保信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row :span="10">
          <a-form-item class="m_span3" :label-col="{ span:3}" label="被保人数量">
            <a-select  @change="numChange" v-decorator="[
                'num',
                {
                  rules: [{ required: true, message: '请选择' }],
                },
              ]" placeholder="请选择投保人数量">
              <a-select-option value="1">1人</a-select-option>
              <a-select-option value="2">2人</a-select-option>
              <a-select-option value="3">3人</a-select-option>
              <a-select-option value="4">4人</a-select-option>
              <a-select-option value="5">5人</a-select-option>
            </a-select>
          </a-form-item>
        </a-row>
        <a-row>
          <a-table :scroll="{ x: 1500 }" :columns="columns" :dataSource="pTableData" :pagination="false" bordered>
            <template slot="operation" slot-scope="text, record, index">
              <div class="operation">
                <span @click="handleEditInsured(index, record)">修改</span>
                <span @click="handleDeleteInsured(index)">删除</span>
              </div>
            </template>
            <template slot="nationality" slot-scope="text">{{ text | formatNationalitye }}</template>
            <template slot="isProtected" slot-scope="text">{{ text | formatValidityType }}</template>
            <template slot="gender" slot-scope="text">{{ text | formatSex }}</template>
            <template slot="idType" slot-scope="text">{{ text | formatIdCardType }}</template>
            <template slot="relationship" slot-scope="text">{{ text | formatrelation }}</template>
          </a-table>
        </a-row>
        <a-col class="btn_list">
          <div class="btn_">
            <a class="btn_a" href="http://ssish.com/policyBilling/sales/Insured_Template_xdlxx1125.xls">
              <a-icon type="download"></a-icon>下载模板
            </a>
          </div>
          <a-upload name="file" :multiple="true" :before-upload="handleFileChange" :customRequest="handleFileChange">
            <div class="btn_">
              <a class="btn_a" href="javascript:;">
                <a-icon type="upload" />批量导入
              </a>
            </div>
          </a-upload>
          <div class="btn_" @click="handleAdd">
            <a class="btn_a">
              <a-icon type="plus" />新增
            </a>
          </div>
        </a-col>
      </a-row>
      <!-- 被保人信息始 -->
      <a-row v-show='false'>
        <div id="start" class="title_">
          <div class="cutleft_">预计保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="预计保费">
            <a-input :disabled="true" v-decorator="[
                'salPolicy.totalPremium',
              ]" />
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 被保人信息末 -->
      <!-- 新增被保人弹框始 -->
      <newInsuredModal @change="handleInsuredChange" :publicParms='publicParms' :oneselfData="oneselfData"
        :operation="operationType" :categoryid='categoryid' :visible.sync="showAddInsuredModal"></newInsuredModal>
      <!-- 新增被保人弹框末 -->
    </a-form>
  </div>
</template>

<script>
  import newInsuredModal from "./newInsuredModal";
  import validatorMixin from "@/mixins/validator";
  const dictOptions = window.utilsdictOptions;
  import { calcTotalPricesA } from "./js/chengZu";
  import moment from "moment";
  const relationList = [
    {
      value: "01",
      name: "雇员"
    }
  ];
  const columns = [
    {
      title: "姓名",
      dataIndex: "name",
      scopedSlots: { customRender: "name" }
    },
    {
      title: "与投保人关系",
      dataIndex: "relationship",
      scopedSlots: { customRender: "relationship" }
    },
    {
      title: "证件类型",
      dataIndex: "idType",
      scopedSlots: { customRender: "idType" }
    },
    {
      title: "证件号码",
      dataIndex: "idNumber",
      scopedSlots: { customRender: "idNumber" }
    },
    {
      title: "证件是否长期",
      dataIndex: "isProtected",
      scopedSlots: { customRender: "isProtected" }
    },
    {
      title: "证件有效起期",
      dataIndex: "idExpiryStart",
      scopedSlots: { customRender: "idExpiryStart" }
    },
    {
      title: "证件有效止期",
      dataIndex: "idExpiryEnd",
      scopedSlots: { customRender: "idExpiryEnd" }
    },
    {
      title: "国籍",
      dataIndex: "nationality",
      scopedSlots: { customRender: "nationality" }
    },
    {
      title: "出生日期",
      dataIndex: "birthDate",
      scopedSlots: { customRender: "birthDate" }
    },
    {
      title: "性别",
      dataIndex: "gender",
      scopedSlots: { customRender: "gender" }
    },
    {
      title: "第一年身故保额",
      dataIndex: "bdieCoverage1",
      scopedSlots: { customRender: "bdieCoverage1" }
    },
    {
      title: "第二年身故保额",
      dataIndex: "bdieCoverage2",
      scopedSlots: { customRender: "bdieCoverage2" }
    },
    {
      title: "第三年身故保额",
      dataIndex: "bdieCoverage3",
      scopedSlots: { customRender: "bdieCoverage3" }
    },
    {
      title: "第四年身故保额",
      dataIndex: "bdieCoverage4",
      scopedSlots: { customRender: "bdieCoverage4" }
    },
    {
      title: "第五年身故保额",
      dataIndex: "bdieCoverage5",
      scopedSlots: { customRender: "bdieCoverage5" }
    },
    {
      title: "操作",
      dataIndex: "operation",
      fixed: "right",
      width: 150,
      scopedSlots: { customRender: "operation" }
    }
  ];
  export default {
    components: { newInsuredModal },
    mixins: [validatorMixin],
    filters: {
      formatSex(val) {
        if (!val) {
          return;
        }
        const item = dictOptions.sexOptions.find(item => {
          return item.value == val;
        });
        return item.name;
      },
      formatNationalitye(val) {
        let nationalityList = [{ "value": "1", "text": "境内" }, { "value": "0", "text": "境外" }]
        if (val == undefined) {
          return;
        }
        return nationalityList.filter(item => item.value == val)[0].text
      },
      formatValidityType(val) {
        if (!val) {
          return;
        }
        return val == 1 ? '是' : '否';
      },
      formatIdCardType(val) {
        if (!val) {
          return;
        }
        const item = dictOptions.commonIdTypeOptions.find(item => {
          return item.value == val;
        });
        return item && item.name;
      },
      formatrelation(val) {
        if (!val) {
          return;
        }
        let arr = [
          { value: 1, text: "本人" },
          { value: 99, text: "其他" },
        ];
        const item = arr.filter(item => item.value == val)[0];
        return item && item.text;
      },
      formatRelationship(val) {
        if (!val) {
          return;
        }
        const item = relationList.find(item => {
          return item.value == val;
        });
        if (item) {
          return item.name;
        }
      }
    },
    data() {
      this.handleIdCardBlurProxy = this.handleIdCardBlur.bind(this);
      return {
        invoicePrintType: '', //基础信息里面的发票类型
        printType: "01", //发票类型
        visible: false,
        columns,
        pTableData: [],
        eTableData: [],
        termYear: '',
        publicParms: {
          invoicePrintType: '',
          wenEmail: "",
          receiveEmail: "",
          cord: "",
          yeEmail: "",
          menberNum: "",
          holderName: "",
          pactType: "",
          destination1: 0,
          destination2: 0,
          destination3: 0,
          destination4: 0,
          destination5: 0,
          effectiveDate: '',
          expireDate: '',
          iptSumAmountFirst: 0,
          idNumber:"",//证件号
          birthDate: "", //出生日期
          idType: "", //身份证类型
          categoryid: "I" //投保人类型
        },
        editingInsuredInfo: {},
        operationType: "add",
        showAddInsuredModal: false,
        planOffsetDay: 0,
        nationalityList: [{ "value": "1", "text": "境内" }, { "value": "0", "text": "境外" }],
        rangeConfig: {
          rules: [{ required: true, message: "请选择时间!" }]
        },
        userParams: {},
        param: {
          //投保参数
        },
        form: this.$form.createForm(this),
        categoryid: "C",
        destination1: "",
        idTypeOptions: [
          {
            name: "身份证",
            value: "1"
          },
          {
            name: "护照",
            value: "2"
          },
          {
            name: "港澳台居民居住证",
            value: "07"
          }
        ],
        oneselfData: {},
        effectiveDate: '',
        expireDate: '',
        ywbm: 5,
        policyIdList: [] //保单号数组
      };
    },

    created() {
      const { u, p } = this.$route.query;
      this.userParams = {
        //从地址中获取
        userId: u,
        productCode: p
      };
    },
    watch: {
      publicParms: {
        handler: function (news) {
          if (news.destination1) {
            this.destination1 = news.destination1;
          }
          if (this.pTableData.length == 0) {
            this.effectiveDate = news.effectiveDate
            this.expireDate = news.expireDate
            return
          }
          if (news.effectiveDate) {
            let oldEffectiveDate = moment(this.effectiveDate).format("YYYY-MM-DD")
            let newEffectiveDate = moment(news.effectiveDate).format("YYYY-MM-DD")
            if (newEffectiveDate != oldEffectiveDate && this.effectiveDate != '') { //保险起息变换
              this.clearInsuranceList('合同期限修改，请重新录入被保人')
              this.effectiveDate = news.effectiveDate
              return
            }
            this.effectiveDate = news.effectiveDate
          }
          if (news.expireDate) {
            let oldExpireDate = moment(this.expireDate).format("YYYY-MM-DD")
            let newExpireDate = moment(news.expireDate).format("YYYY-MM-DD")
            if (newExpireDate != oldExpireDate && this.effectiveDate != '') { //保险截止变换
              this.clearInsuranceList('合同期限修改，请重新录入被保人')
            }
            this.expireDate = news.expireDate
          }
        },
        deep: true,
      },
      policyIdList: {
        handler: function (news) {
          if (news.length == this.pTableData.length) {
            this.$emit("policyId", news.toString());
          }
        },
        deep: true
      }
    },
    beforeDestroy() {
      this.$bus.$off("salInsuredList");
      this.$bus.$off("busPublicParms");
      this.$bus.$off("policyInfo");
    },
    mounted() {
      this.$bus.$on("salInsuredList", (data) => { //被保人列表
        this.pTableData = data
      });
      this.$bus.$on("busPublicParms", (data, changeCoverage) => {
        this.publicParms = data
        this.$nextTick(() => {
          this.form.setFieldsValue({ //自动带出投保人名称
            salPolicyHolder: {
              name: this.publicParms.holderName
            }
          });
        })
        this.termYear = data.termYear
         // 是否触发均分保费
        if(changeCoverage) {
          this.coverageAmount();
        }
        let value = this.form.getFieldsValue();
        let obj = {
          tableData: [...this.pTableData],
          values: value
        };
        this.handleCZChange(obj);
      });
      this.$bus.$on("policyInfo", (data) => { //投保人信息
        const { num } = data
        const { name, type, telephone, idType, idNumber } = data.salPolicyHolder
        this.categoryid = type //投保类型
        this.$nextTick(() => {
          this.form.setFieldsValue({
            categoryid: type,
            num: num.toString(),
            salPolicyHolder: {
              name, telephone, idType, idNumber
            }
          });
        })
      });
      if (this.publicParms.destination1) {
        this.destination1 = this.publicParms.destination1;
      }
      this.ywbm = 5
    },
    methods: {
      //投保人名称改变
      moment,
      // 清空被保人列表
      clearInsuranceList(msg) {
        this.pTableData = []
        let obj = {
          tableData: []
        };
        this.$message.warning(msg);
        this.handleCZChange(obj);
      },
      //判断是几年的保额
      judgeYearAmount() {
        let someYear = this.termYear
        if (someYear > 5) {
          return 5
        } else {
          return someYear
        }
      },
      judgeData(value) {
        let ywbm = this.ywbm
        if (moment(value).isBefore(moment(this.publicParms.effectiveDate).add(ywbm, "year"))) {
          return value
        } else {
          return moment(this.publicParms.effectiveDate).add(ywbm, "year")
        }
      },
      //基础信息里面的发票类型变化时
      invoicePrintTypeChange(type) {
        this.invoicePrintType = type;
      },
      handleIdCardBlurProxy() { },
      changeTime() {
        this.time = moment("2021-03-05");
      },
      destinationChange(value, key) {
        if (key == "telephone") {
          if (!this.$checkPhone.test(value)) {
            this.$message.warning("请输入正确的联系人手机号");
            this.form.setFieldsValue({
              salPolicyHolder: {
                telephone: ""
              }
            });
            return
          }
        }
      },
      validateInput(e, key) {
        //input交验
        let val = e.target.value,
          _this = this;
        let phoneR = /(^(0)?(13[0-9]|14[5|7|8|9]|15[0-9]|166|18[0-9]|17[0|1|3|5|6|7|8]|19[8|9])[0-9]{8}$)|(^(00852|00886|00853)[0-9]{1,15}$)/;
        let idNoReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
        let idType = _this.form.getFieldValue("salPolicyHolder.idType");
        switch (key) {
          case "telephone":
            if (!phoneR.test(val)) {
              _this.$message.warning("请输入正确手机号");
              _this.form.setFieldsValue({
                salPolicyHolder: {
                  telephone: ""
                }
              });
            }
            break;
          case "idNumber":
            if (idType == "1") {
              if (!idNoReg.test(val)) {
                _this.$message.warning("请输入正确的身份证号");
                _this.form.setFieldsValue({
                  salPolicyHolder: {
                    idNumber: ""
                  }
                });
              } else {
                this.handleIdCardBlurProxy(
                  "form",
                  "salPolicyHolder.idType",
                  "salPolicyHolder.idNumber",
                  "salPolicyHolder.gender",
                  "salPolicyHolder.birthDate"
                );
              }
            }
            break;
        }
      },
      //表单提交
      async czSubmit() {
        this.policyIdList = []; //初始化保单数组
        this.$emit('coverageAmount', {
          underAmount: 0,
          underAmountMsg: ''
        })
        const saveData =  await this.selectCoverageAmount(this.pTableData, true)
        return saveData
      },
      assembleParms() { //组装pamrs
        let validState = false
        this.form.validateFields((err, values) => {
          if (!err) {
            let pTableData = Array.from([...this.pTableData])// 处理数据格式
            this.coveragePremium(values.salPolicy.totalPremium) //拼装个人保费
            let params = {};
            let publicParms = JSON.parse(sessionStorage.getItem("publicParms"))
           

            if (pTableData.length > values.num) {
              this.$message.warning("被保人人数超出所选范围");
              validState = true
              return;
            }
            //保费大于0校验
            let NUMNULL = this.judgeYearAmount()
            for (let i = 0; i <= NUMNULL; i++) {
              const element = 'destination' + i;
              if (element <= 0) {
                this.$message.warning("各年租金不能为零");
                validState = true
                return;
              }
            }
            let destination1 = 0;
            let destination2 = 0;
            let destination3 = 0;
            let destination4 = 0;
            let destination5 = 0;
            pTableData.forEach((elements) => {
              // 被保人保额 对比 总保额
              destination1 +=
                elements.bdieCoverage1 != ""
                  ? parseInt(elements.bdieCoverage1)
                  : 0;
              destination2 +=
                elements.bdieCoverage2 != ""
                  ? parseInt(elements.bdieCoverage2)
                  : 0;
              destination3 +=
                elements.bdieCoverage3 != ""
                  ? parseInt(elements.bdieCoverage3)
                  : 0;
              destination4 +=
                elements.bdieCoverage4 != ""
                  ? parseInt(elements.bdieCoverage4)
                  : 0;
              destination5 +=
                elements.bdieCoverage5 != ""
                  ? parseInt(elements.bdieCoverage5)
                  : 0;
            });
            
            if (
              destination1 != (publicParms.destination1 || 0) ||
              destination2 != (publicParms.destination2 || 0) ||
              destination3 != (publicParms.destination3 || 0) ||
              destination4 != (publicParms.destination4 || 0) ||
              destination5 != (publicParms.destination5 || 0)
            ) {
              this.$message.warning("被保人保额不等于总保额，请重新录入!");
              validState = true
              return;
            }
            this.pTableData.forEach(element => {
              element.salInsuredExt = {}
              params.salInsuredList = [];
              params.salPolicy.totalPremium = element.premium.split(',')[5]
              element.salInsuredExt.idExpiryStart = element.idExpiryStart
              element.salInsuredExt.idExpiryEnd = element.idExpiryEnd
              element.type = publicParms.categoryid
              params.salInsuredList.push(element);
            })
          }
        });
         if (!validState) {
          return this.pTableData
        }
        return false
      },
      numChange(val){ //被保人数量改变
        this.coverageAmount(val, true)
        if(this.pTableData.length > 0) {
          this.clearInsuranceList('被保人数量修改，请重新录入被保人')
        }
      },
      handleCZChange(options) {//保费计算
        this.$emit('coverageAmount', {
          underAmount: 0,
          underAmountMsg: ''
        })
        this.selectCoverageAmount(options.tableData)//校验保费超额
        if (options) {
          let obj = {
            salPolicy: {
              destination1: this.publicParms.destination1,
              destination2: this.publicParms.destination2,
              destination3: this.publicParms.destination3,
              destination4: this.publicParms.destination4,
              destination5: this.publicParms.destination5,
              effectiveDate: moment(this.publicParms.effectiveDate).format("YYYY-MM-DD"),
              expireDate: moment(this.publicParms.expireDate).format("YYYY-MM-DD")
            },
            tableData: options.tableData
          };
          const totalNum = calcTotalPricesA(obj);
          this.$emit("totalPremium", totalNum);
          this.form.setFieldsValue({ "salPolicy.totalPremium": totalNum });
          this.$forceUpdate()
        }
      },
      displayAge(birth, target) { //判断年龄
        let months = target.diff(birth, 'months', true)
        let birthSpan = { year: Math.floor(months / 12), month: Math.floor(months) % 12, day: Math.round((months % 1) * target.daysInMonth(), 0) }
        return birthSpan.year
      },
      async selectCoverageAmount(data, bol) { //判断被保人保费是否超额
        let effectiveDate = this.publicParms.effectiveDate
        let list = data.map(item => {
          let { name, idNumber, idType, bdieCoverage1, years } = item
          return item = {
            name, idNumber,
            idType, coverage: bdieCoverage1,
            age: years,
            effectiveDate: moment(effectiveDate).format("YYYY-MM-DD")//起租日期
          }
        })
        let valid = false
        await this.$api.selectCoverageAmount(list).then(res => {
          const h = this.$createElement;
          if (res.data.content && res.data.content.code == '999') {
            this.$emit('coverageAmount', {
              underAmount: 2,
              underAmountMsg: res.data.content.message
            })
            if (res.data.content.message) {
              let message = JSON.parse(res.data.content.message)
              let arr = []
              message.forEach(element => {
                arr.push(h('p', `被保人${element.name}，年龄${element.age}岁；此次投保意外险保额为${element.coverage}元；剩余可投保保额为：${element.surplusPremium}元;  本次投保已超过累计保额，请联系保险科！`))
              })
              this.$message.warning({
                content: h('div', {}, arr), duration: 3
              });
            }
          }
          
          if(res.data.content.code == "00") {
            this.$emit('coverageAmount', {
              underAmount: 0,
              underAmountMsg: ''
            })
          }
          if(res.data.content.code == "222") {
            // 调用利宝接口失败
            valid = true
          }
        }).catch(() => { 
          this.$emit('coverageAmount', {
            underAmount: 0,
            underAmountMsg: ''
          })
          this.$emit("savefail")
        });
        if(valid) {
          this.$message.warning('校验意外险保额失败')
          return
        }
        if (bol) { //异步提交
          return this.assembleParms()
        } else {
          return false
        }
      },
      handleFileChange(file, fileList) {
        let datas = this.form.getFieldsValue();
        let effectiveDate = this.publicParms.effectiveDate
        if (!file.method) {
          if (!datas.num) {
            this.$message.warning(`请选择被保人数量！`, 3);
            return;
          }
          if (!effectiveDate) {
            this.$message.warning(`请选择起租时间！`, 3);
            return;
          }
        }
        if (fileList != undefined) {
          const formData = new FormData();
          formData.append("file", file);
          let _this = this;
          this.$api.zlParseInsuredExcel(formData).then(res => {
            let dataArr = res.data.content;
            dataArr.map(item => {
              let ageType
              let years
              let nationality
              let pass = true
              if (!this.$regTest.checkIdCard(item.insIdNumber) && item.insIdType === "身份证") {
                this.$message.warning(`被保人${item.insName}身份证号不正确,请重新添加`, 3);
                pass = false;
              }
              if (item.insBirthday) {
                years = this.displayAge(moment(item.insBirthday), moment(this.publicParms.effectiveDate))
                if (years < 18 || years > 70) {
                  this.$message.warning(`被保人${item.insName}年龄需18~70岁,请重新添加`, 6);
                  pass = false
                }
                if (years > 65) {
                  ageType = 1
                }
              }
              if (item.insIdType == '护照') {
                nationality = 0
              } else {
                nationality = 1
              }
              let item_ = {
                name: item.insName,
                idType: _this.filterIdType(item.insIdType),
                idNumber: item.insIdNumber,
                birthDate: item.insBirthday,
                gender: _this.filterSex(item.insGender),
                mobile: item.phone,
                ageType: ageType,
                years: years,
                isProtected: item.isProtected == '是' ? '1' : '2',
                nationality: nationality,
                idExpiryStart: item.idExpiryStart,
                idExpiryEnd: item.idExpiryEnd,
                relationship: this.categoryid == 'I' ? '1' : '99',
                premium: 0
              };
              if (_this.pTableData.length >= datas.num) {
                this.$message.warning(`被保人数量超出选择范围`, 3);
                return
              }
              if (pass) {
                _this.pTableData.push(item_);
              }
            });
            this.coverageAmount();
            let value = this.form.getFieldsValue();
            let obj = {
              tableData: [..._this.pTableData],
              values: value
            };
            this.handleCZChange(obj);
          });
        }
      },
      filterSex(val) {
        //性别类型
        if (val == "男") {
          return "M";
        } else if (val == "女") {
          return "F";
        }
      },
      filterNationality(val) {
        let nationalityList = [{ "value": "1", "text": "境内" }, { "value": "0", "text": "境外" }]
        if (!val) {
          return '';
        }
        return nationalityList.filter(item => item.text == val)[0].value
      },
      filterShip(val) {
        let arr = [
          { value: 1, text: "本人" },
          { value: 2, text: "配偶" },
          { value: 3, text: "子女" },
          { value: 4, text: "父母" },
          { value: 5, text: "其他" }
        ];
        const item = arr.find(item => {
          return item.text == val;
        });
        return item && item.value;
      },
      filterIdType(val) {
        //身份类型过滤
        let v = "";
        this.idTypeOptions.forEach(item => {
          if (val == item.name) {
            v = item.value;
          }
        });
        return v;
      },
      handleInsuredChange(options) {
        //新增人员组件传递信息
        const item = {
          ...options.data
        };
        if (options.type == "add") {
          let isPass = true;
          this.pTableData.map(ele => {
            if (ele.idNumber == item.idNumber) {
              this.$message.warning(`被保人${ele.name}重复`, 3);
              isPass = false;
            }
          });
          if (isPass) {
            this.pTableData.push(item);
          }
        } else {
          this.pTableData[this.operationIndex] = item;
        }
        let value = this.form.getFieldsValue();
        let obj = {
          tableData: this.pTableData,
          values: value
        };
        this.handleCZChange(obj);
      },
      handleEditInsured(index) {
        //修改
        this.showAddInsuredModal = true;
        this.operationIndex = index;
        this.operationType = "edit";
        this.editingInsuredInfo = this.pTableData[index];
        this.$set(this.editingInsuredInfo, 'bdieCoverage1', this.pTableData[index].bdieCoverage1)
        this.$bus.$emit("busEditingInsuredInfo", this.editingInsuredInfo);
      },
      handleDeleteInsured(index) {//删除
        this.pTableData.splice(index, 1);
        let value = this.form.getFieldsValue();
        let obj = {
          tableData: this.pTableData,
          values: value
        };
        this.handleCZChange(obj);
      },
      handleAdd() {
        let datas = this.form.getFieldsValue();
        let effectiveDate = this.publicParms.effectiveDate
        if (!datas.num) {
          this.$message.warning(`请选择被保人数量`, 3);
          return;
        }
        if (!effectiveDate) {
          this.$message.warning(`请选择起租时间！`, 3);
          return;
        }
        if (this.pTableData.length >= datas.num) {
          this.$message.warning(`被保人数量超过选择范围`, 3);
          return;
        }
        let num1 = this.coverageAmount(datas.num);
        this.editingInsuredInfo = {
          bdieCoverage1: num1[0],
          bdieCoverage2: num1[1],
          bdieCoverage3: num1[2],
          bdieCoverage4: num1[3],
          bdieCoverage5: num1[4]
        }
        this.showAddInsuredModal = true;
        this.operationType = "add";
        this.$bus.$emit("busEditingInsuredInfo", this.editingInsuredInfo);
        this.$bus.$emit("busTermYear", this.termYear, this.publicParms.ywbm);
      },
      handleOk() {
        this.visible = false;
      },
      handleCancel() {
        this.visible = false;
      },
      disabledDate(current) {
        return current && current < moment().endOf("day");
      },
      // rangePicker(values) {
      //   if (values) {
      //     let expireDate = moment(values).format("YYYY-MM-DD");
      //     let startData = this.form.getFieldValue("effectiveDate");
      //     let offsetDay = values.diff(startData, "days") + 1;
      //     this.planOffsetDay = offsetDay;
      //     let value = this.form.getFieldsValue();
      //     value.expireDate = expireDate; //手动传入新日期   get获取有异步延时问题
      //     let obj = {
      //       tableData: this.pTableData,
      //       values: value
      //     };
      //     this.handleCZChange(obj);
      //   }
      // },
      resetForm() {
        this.form.resetFields();
      },
      checkFields() {
        if (this.pTableData.length == 0) {
          this.$message.error("被保人列表不能为空");
          this.$emit("checked", false);
          return;
        }
        let data = this.pTableData[0];
        for (var item in data) {
          if (
            (item == "name" ||
              item == "relationship" ||
              item == "idType" ||
              item == "idNumber" ||
              item == "birthDate" ||
              item == "gender" ||
              item == "") &&
            data[item] == ""
          ) {
            this.$message.error("被保人信息不全");
            this.$emit("checked", false);
            return;
          }
        }
        this.form.validateFields((err) => {
          if (!err) {
            this.$emit("checked", true);
          } else {
            this.$emit("checked", false);
          }
        });
      },
      PrintTypeChange(value) {
        this.printType = value.target.value;
      },
      policyNameChange() {
        let data = this.pTableData[0];
        let tempData = {
          ...data,
          name: this.policyName
        };
        this.pTableData[0] = tempData;
      },
      getRentConverProportion(str) {
        const feilvObj = {
          1: 1.2,
          2: 1.25,
          3: 1.3,
          4: 1.35,
          5: 1.4
        }
        return feilvObj[str] || 0;
      },

      /**
       * 均分保费
       */
      coveragePremium() {
        this.pTableData.forEach((element) => {
          //组装被保人保额 保费
          element.premium = `${element.bdieCoverage1 ||
            0},${element.bdieCoverage2 || 0},${element.bdieCoverage3 ||
            0},${element.bdieCoverage4 || 0},${element.bdieCoverage5 ||
            0},${element.premiumComputed}`;
        });
      },
      /**
       * 身故保额验证
       */
      validforehead(iptSumAmount,  str) {
        const feilv = this.getRentConverProportion(str)
        const destination = this.publicParms['destination'+str]
        if (parseInt(iptSumAmount) > destination * feilv) {
              this.$message.warning(
                ` 第${str}年身故保额小于等于第${str}年应付金额的${feilv * 100}%,并且不大于600万,请重新输入身故保额！"`,
                3
              );
              this.$emit("emitPamrs", { ['destination'+str]: "" });
            }
      },
      /**
       * 均分保额
       */
      coverageAmount(num,type) {
        let datas = this.form.getFieldsValue();
        var iptSumAmountFirst = this.publicParms.destination1;
        var iptSumAmountSecond = this.publicParms.destination2;
        var iptSumAmountThird = this.publicParms.destination3;
        var iptSumAmountFour = this.publicParms.destination4;
        var iptSumAmountFive = this.publicParms.destination5;
        var insuredSize = num || datas.num;
        var ageType = 0
        var iptSumAmountFirstAgeType = false
        var iptSumAmountSecondAgeType = false
        var iptSumAmountThirdAgeType = false
        var iptSumAmountFourAgeType = false
        var iptSumAmountFiveAgeType = false
        ageType = this.pTableData.filter(item => item.ageType == 1).length
        var converageOne = 0,
          converageTwo = 0,
          converageThree = 0,
          converageFour = 0,
          converageFive = 0;
        var yushuOne = 0,
          yushuTwo = 0,
          yushuThree = 0,
          yushuFour = 0,
          yushuFive = 0;
        //判断65-70
        if (ageType > 0) {
          if (insuredSize * 2000000 < parseInt(iptSumAmountFirst)) {
            iptSumAmountFirst = iptSumAmountFirst - ageType * 2000000
            iptSumAmountFirstAgeType = true
          }
          if (insuredSize * 2000000 < parseInt(iptSumAmountSecond)) {
            iptSumAmountSecond = iptSumAmountSecond - ageType * 2000000
            iptSumAmountSecondAgeType = true
          }
          if (insuredSize * 2000000 < parseInt(iptSumAmountThird)) {
            iptSumAmountThird = iptSumAmountThird - ageType * 2000000
            iptSumAmountThirdAgeType = true
          }
          if (insuredSize * 2000000 < parseInt(iptSumAmountFour)) {
            iptSumAmountFour = iptSumAmountFour - ageType * 2000000
            iptSumAmountFourAgeType = true
          }
          if (insuredSize * 2000000 < parseInt(iptSumAmountFive)) {
            iptSumAmountFive = iptSumAmountFive - ageType * 2000000
            iptSumAmountFiveAgeType = true
          }
        }
        if (iptSumAmountFirstAgeType || iptSumAmountSecondAgeType || iptSumAmountThirdAgeType || iptSumAmountFourAgeType || iptSumAmountFiveAgeType) {
          insuredSize = insuredSize - ageType
        }
        if (iptSumAmountFirst != undefined && iptSumAmountFirst != "") {
          converageOne = parseInt(parseInt(iptSumAmountFirst) / insuredSize);
          yushuOne =
            parseInt(iptSumAmountFirst) - parseInt(converageOne) * insuredSize;

          let destination = this.publicParms.destination1;
          let str = 1;
          if (iptSumAmountFirst == "") {
            return;
          } else if (iptSumAmountFirst != "" && destination == "") {
            this.$message.warning("请先输入第" + str + "年租金", 3);
          } else {
            this.validforehead(iptSumAmountFirst, 1)
          }
        }
        if (iptSumAmountSecond != undefined && iptSumAmountSecond != "") {
          converageTwo = parseInt(parseInt(iptSumAmountSecond) / insuredSize);
          yushuTwo =
            parseInt(iptSumAmountSecond) - parseInt(converageTwo) * insuredSize;

          let destination = this.publicParms.destination2;
          let str = 2;
          if (iptSumAmountSecond == "") {
            return;
          } else if (iptSumAmountSecond != "" && destination == "") {
            this.$message.warning("请先输入第" + str + "年租金", 3);
            this.$emit("emitPamrs", { destination2: "" });
          } else {
            this.validforehead(iptSumAmountSecond, 2)
          }
        }
        if (iptSumAmountThird != undefined && iptSumAmountThird != "") {
          converageThree = parseInt(parseInt(iptSumAmountThird) / insuredSize);
          yushuThree =
            parseInt(iptSumAmountThird) - parseInt(converageThree) * insuredSize;

          let destination = this.publicParms.destination3;
          let str = 3;
          if (iptSumAmountThird == "") {
            return;
          } else if (iptSumAmountThird != "" && destination == "") {
            this.$message.warning("请先输入第" + str + "年租金", 3);
            this.$emit("emitPamrs", { destination3: "" });
          } else {
            this.validforehead(iptSumAmountThird, 3)
          }
        }
        if (iptSumAmountFour != undefined && iptSumAmountFour != "") {
          converageFour = parseInt(parseInt(iptSumAmountFour) / insuredSize);
          yushuFour =
            parseInt(iptSumAmountFour) - parseInt(converageFour) * insuredSize;

          let destination = this.publicParms.destination4;
          let str = 4;
          if (iptSumAmountFour == "") {
            return;
          } else if (iptSumAmountFour != "" && destination == "") {
            this.$message.warning("请先输入第" + str + "年租金", 3);
            this.$emit("emitPamrs", { destination4: "" });
          } else {
            this.validforehead(iptSumAmountFour, 4)
          }
        }
        if (iptSumAmountFive != undefined && iptSumAmountFive != "") {
          converageFive = parseInt(parseInt(iptSumAmountFive) / insuredSize);
          yushuFive =
            parseInt(iptSumAmountFive) - parseInt(converageFive) * insuredSize;

          let destination = this.publicParms.destination5;
          let str = 5;
          if (iptSumAmountFive == "") {
            return;
          } else if (iptSumAmountFive != "" && destination == "") {
            this.$message.warning("请先输入第" + str + "年租金", 3);
            this.$emit("emitPamrs", { destination5: "" });
          } else {
            this.validforehead(iptSumAmountFive, 5)
          }
        }
        if (num&&!type) {
          let length = this.pTableData.length
          let arr = [
            converageOne,
            converageTwo,
            converageThree,
            converageFour,
            converageFive
          ];
          if (yushuOne >= 1 && length < yushuOne) {
            arr[0] = parseInt(converageOne) + parseInt(1);
          }
          if (yushuTwo >= 1 && length < yushuTwo) {
            arr[1] = parseInt(converageTwo) + parseInt(1);
          }
          if (yushuThree >= 1 && length < yushuThree) {
            arr[2] = parseInt(converageThree) + parseInt(1);
          }
          if (yushuFour >= 1 && length < yushuFour) {
            arr[3] = parseInt(converageFour) + parseInt(1);
          }
          if (yushuFive >= 1 && length < yushuFive) {
            arr[4] = parseInt(converageFive) + parseInt(1);
          }
          return arr
        }
        this.pTableData.forEach((element, item) => {
          element.bdieCoverage1 = converageOne;
          element.bdieCoverage2 = converageTwo;
          element.bdieCoverage3 = converageThree;
          element.bdieCoverage4 = converageFour;
          element.bdieCoverage5 = converageFive;
          if (yushuOne >= 1 && item < yushuOne) {
            element.bdieCoverage1 = parseInt(converageOne) + parseInt(1);
          }
          if (yushuTwo >= 1 && item < yushuTwo) {
            element.bdieCoverage2 = parseInt(converageTwo) + parseInt(1);
          }
          if (yushuThree >= 1 && item < yushuThree) {
            element.bdieCoverage3 = parseInt(converageThree) + parseInt(1);
          }
          if (yushuFour >= 1 && item < yushuFour) {
            element.bdieCoverage4 = parseInt(converageFour) + parseInt(1);
          }
          if (yushuFive >= 1 && item < yushuFive) {
            element.bdieCoverage5 = parseInt(converageFive) + parseInt(1);
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  $themeC: rgba(254, 143, 45, 1);

  @media screen and (min-width: 500px) {
    .child_ {
      .wid_150 {
        width: 150px;
      }

      .marL_10 {
        margin-left: 10px;
      }

      .title_ {
        margin: 30px 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .cutleft_ {
          font-size: 16px;
          font-family: Microsoft YaHei UI;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          // width: 10%;
        }

        .cutoff_ {
          // width:90%;
          flex: 1;
          height: 5px;
          background: #f0f0f0;
        }
      }

      .operation {
        text-align: center;
      }

      .operation span {
        display: inline-block;
        background-color: #fe8f2d;
        color: #fff;
        border-radius: 3px;
        padding: 3px 10px;

        &:last-child {
          margin-left: 20px;
        }
      }

      .btn_list {
        display: flex;
        justify-content: center;

        .btn_ {
          margin: 19px;
          border: 1px solid $themeC;
          width: 150px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;

          .btn_a {
            text-align: center;
            color: $themeC;
          }
        }
      }

      .btn_color {
        background: $themeC;
        border: 1px solid $themeC;
      }

      .shopsname {
        width: 500px;
        margin-right: 10px;
      }
    }
  }

  // 移动端适配
  @media screen and (max-width: 500px) {
    .child_ {
      .planSelect {
        width: 170px;
      }

      .ant-col-10 {
        width: 100%;
      }

      .ant-col-20 {
        width: 100%;
      }

      .ant-col-12 {
        width: 100%;
      }

      .ant-form-item-label {
        line-height: 40px;
        font-size: 12px;
      }

      .ant-col-offset-2 {
        margin-left: 0;
      }

      .ant-form-item-required::before {
        margin-right: 0px;
      }

      .m_span3>>>.ant-col-6 {
        width: 25%;
      }

      .m_row {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .m_span6 {
          width: 220px;

          .formItem {
            .ant-col {
              color: red;
            }
          }
        }

        .ant-col-6 {
          width: 220px;
        }

        .ant-col-3 {
          width: 130px;
        }
      }

      .shopsname {
        width: 250px;
      }
    }

    .btn_list {
      display: flex;
      justify-content: center;

      .btn_ {
        margin: 10px;
        border: 1px solid $themeC;
        padding: 0 10px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;

        .btn_a {
          text-align: center;
          color: $themeC;
        }
      }
    }
  }
</style>